export const SYSTEM_ADMIN_ROLE_CODES = [
  'company_admin',
  'engineering_admin',
  'project_admin',
  'labor_admin',
  'super_admin_g'
]

export const ORG_ADMIN_ROLE_CODES = [
  'labor_admin',
  'engineering_admin',
  'project_admin',
  'company_admin'
]

export const LOCKED_ROLE_BUTTONS = [0, 1, 2, 3, 'edit', 'delete', 'set']

export function isSuperAdminFromRoot(rootState) {
  const admin = (rootState && rootState.superAdminName) || 'dpnadmin'
  const user = (rootState && rootState.user) || {}
  return user.userName === admin || user.personName === admin
}

export function isSystemAdminRoleCode(code) {
  return SYSTEM_ADMIN_ROLE_CODES.indexOf(String(code || '').trim()) >= 0
}

function changeFlag(value) {
  if (value === true || value === 1 || value === '1') return '1'
  return String(value == null ? '' : value).trim()
}

export function isLockedOrgRole(item) {
  if (!item) return false
  if (isSystemAdminRoleCode(item.roleCode)) return true
  const flag = changeFlag(item.isChange)
  if (!flag) return false
  return flag !== '1'
}

export function pickOrgAdminRole(orgRoles) {
  const list = orgRoles || []
  for (let i = 0; i < ORG_ADMIN_ROLE_CODES.length; i++) {
    const code = ORG_ADMIN_ROLE_CODES[i]
    const found = list.find((item) => item && item.roleCode === code)
    if (found) return found
  }
  return null
}
